module.exports = __webpack_public_path__ + "img/Autajon.db6bda67.jpg";